import { render, staticRenderFns } from "./SortOrderInput.vue?vue&type=template&id=6077a3b0&"
import script from "./SortOrderInput.vue?vue&type=script&lang=ts&"
export * from "./SortOrderInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports